<template>
  <ExamReady :path="'/entrain'"></ExamReady>
</template>

<script>
  import ExamReady from '@/page/modules/exam/ready'
  export default {
    components: { ExamReady },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/entrain/exam/ready.vue